import { EventHandlerListener } from 'web-core-src';
import { IEventHandler } from './event-handler.interface';

export class EventHandler implements IEventHandler {
    private listenerArraysContainer: any = {};

    public on<T>(eventName: string, listener: EventHandlerListener<T>): EventHandlerListener<T> {
        if (typeof this.listenerArraysContainer[eventName] !== 'object') {
            this.listenerArraysContainer[eventName] = [];
        }

        this.listenerArraysContainer[eventName].push(listener);
        return listener;
    }

    public removeListener<T>(eventName: string, listener: EventHandlerListener<T>): void {
        let idx: number;

        if (typeof this.listenerArraysContainer[eventName] === 'object') {
            idx = this.listenerArraysContainer[eventName].indexOf(listener);

            if (idx > -1) {
                this.listenerArraysContainer[eventName].splice(idx, 1);
            }
        }
    }

    public emit<T>(eventName: string, args?: T): void {
        if (typeof this.listenerArraysContainer[eventName] === 'object') {
            let listeners: Function[] = this.listenerArraysContainer[eventName].slice();
            listeners.forEach((listener: Function): void => {
                listener.apply(this, [args]);
            });
        }
    }

    public once<T>(eventName: string, listener: EventHandlerListener<T>): void {
        this.on(eventName, function g(): void {
            this.removeListener(eventName, g);
            listener.apply(this, arguments);
        });
    }
}
